// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","border":"Button_border__fI7zx","disabled":"Button_disabled__PUkNe","loader":"Button_loader__S3BdI"};